export enum Stend {
  Dev,
  Stage,
  Prod
}
